import { idFactory } from "./idFactory";

export const createFileId = (args: { extension: string }) => `${idFactory.createFileId()}.${args.extension}`;
